import { truncate } from 'lodash';

export const multiLineTruncate = (text: string, length: number) => {
    const lines = text.split('\n');
    return truncate(lines[0] || '', { length });
};
